import styled, { createGlobalStyle } from 'styled-components';

export const SplittedHeroWrapper = styled.div`
  a,
  button {
    display: flex;
    justify-content: center;
  }
`;

export const ChatStyle = createGlobalStyle`
  .zEWidget-launcher.zEWidget-launcher--active {
    @media (max-width: ${props => props.theme.breakpoints.maxWidth.S}) {
      display: none;
    }
  }
`;

export const Background = styled.div`
  background-color: ${props => props.theme.colors.primaryBackground()};
  padding: 0 20px;
  width: 100%;

  @media (max-width: ${props => props.theme.breakpoints.maxWidth.S}) {
    padding: 0;
  }

  &.no-padding {
    padding: 0;
  }
`;

export const Card = styled.div`
  border-radius: ${props => props.theme.borders.cardRadius};
  color: ${props => props.theme.colors.textQuote()};
  margin: 0 auto 10px;
  padding: 0 20px;
  position: relative;
  transition: border 1s ease;
  width: 100%;
`;

// Do not change padding-[bottom|top] to padding
export const Container = styled.div<{ maxWidth?: string }>`
  color: ${props => props.theme.colors.textQuote()};
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: ${props => props.maxWidth || '935px'};
  padding-bottom: 60px;
  width: 100%;

  &.medium {
    padding-bottom: 35px;

    @media (max-width: ${props => props.theme.breakpoints.maxWidth.S}) {
      padding-bottom: 20px;
    }
  }

  @media (max-width: ${props => props.theme.breakpoints.maxWidth.S}) {
    padding-bottom: 30px;
    padding-top: 20px;
  }

  &.centered {
    align-items: center;
  }

  &.small {
    padding-bottom: 0;
    padding-top: 0;
  }

  &.row {
    padding-bottom: 20px;
    padding-top: 30px;
  }

  &.table {
    margin-top: 80px;
  }
`;

export const InnerContainer = styled(Container)`
  border-bottom: solid 1px rgba(72, 72, 72, 0.1);
  padding-bottom: 60px;
  padding-top: 60px;

  @media (max-width: ${props => props.theme.breakpoints.maxWidth.S}) {
    padding-bottom: 30px;
    padding-top: 30px;
  }

  &.small {
    padding-bottom: 20px;
    padding-top: 20px;
  }

  :first-child {
    :not(:last-child) {
      padding-top: 0;
    }
  }

  :last-child {
    border-bottom: 0;

    :not(:first-child) {
      padding-bottom: 0;
    }
  }

  :first-child {
    :last-child {
      border-bottom: 0;
    }
  }
`;

export const TopContainer = styled(Container)`
  position: relative;
  top: -40px;
  padding: 0;

  @media (max-width: ${props => props.theme.breakpoints.maxWidth.S}) {
    top: 0px;
  }
`;

export const Row = styled.div`
  display: flex;

  &.spaced {
    justify-content: space-between;
  }
`;

export const HeaderContainer = styled.div`
  background-color: ${props => props.theme.colors.textQuote(0.05)};
  display: flex;
  justify-content: space-between;
  padding: 10px;
`;

export const TripSelectionPageContainer = styled.div`
  color: ${props => props.theme.colors.textQuote()};
  background-color: ${props => props.theme.colors.textQuote(0.03)};
  display: flex;
  flex-direction: column;
  padding: 20px 20px 0;

  @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
    text-align: center;
    padding: 20px 0;

    &.text-left {
      text-align: left;
    }
  }

  @media (min-width: ${props => props.theme.breakpoints.minWidth.XS}) {
    align-items: center;
  }

  form {
    width: 100%;
  }
`;

export const CardLinksContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
  margin-top: 10px;
  max-width: 800px;
  width: 100%;

  @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
    margin-bottom: 80px;
    width: auto;
  }

  path,
  .circle {
    fill: ${props => props.theme.colors.primary()};
  }

  &.with-submit {
    button {
      margin-top: 20px;
    }
  }
`;

export const SelectionContainer = styled.div`
  background-color: ${props => props.theme.colors.textQuote(0.03)};
  display: flex;
  justify-content: center;
  padding: 20px 0 0;

  @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
    background-color: #fff;
    padding-bottom: 40px;
  }
`;
